import React, { Component } from 'react';

export default class SectionHeader extends Component {
    render() {
        const { fieldDef } = this.props;

        return (
            <div className="col-12 mt-3 mb-2">
                <h5 style={{ borderBottom: '1px solid rgba(0,0,0,.1)', paddingBottom: '5px' }}>
                    {fieldDef.label}
                </h5>
                {fieldDef.helpText && (
                    <small className="text-muted">{fieldDef.helpText}</small>
                )}
            </div>
        );
    }
}
